import { isInternal } from "../../../helpers";
import { useSetPriceBySqft, useWindowSize } from "../../../hooks";
import { BlockCheckbox } from "../../fields";

export const FurnishedFpProduct = () => {
  const furnished_price = useSetPriceBySqft("2017", 1000);
  const { isNotSmall } = useWindowSize();

  return (
    <div>
      <BlockCheckbox
        sku="2017"
        defaultValue={!isInternal()}
        custom_price={furnished_price}
        short_labels={!isNotSmall}
        col={false}
      />
    </div>
  );
};
